module.exports = __webpack_public_path__ + "static/media/design.20d40ea8.jpg";